const Marquee = ({ title }) => {
  // Split title into words
  const words = title.split(" ");

  return (
    <div className="marquee-box">
      <div className="marquee-text">
        {words.map((word, i) => (
          <span
            key={i}
            className={
              i % 2 === 0 ? "marquee-word-primary" : "marquee-word-white"
            }
          >
            {word}{" "}
          </span>
        ))}
      </div>

      {/* Lights around the marquee */}
      <div className="lights">
        {[...Array(40)].map((_, i) => (
          <span key={i} className="light"></span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
